<div class="modal-header">
    <button class="btn btn-success" (click)="downloadData();">
        <span *ngIf="!buttonLoader" class="feather icon-download mr-1"></span>
        <span *ngIf="buttonLoader" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Download
    </button>
    <h5 class="modal-title font-weight-bold mt-2" id="modal-basic-title">Merchants List (Declining sales in Last {{customDays}} days than expected)</h5>
    <button type="button" class="close mt-2" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="card-body logs">
    <div class="pb-md-3 table-responsive" style="overflow: auto; height: 500px">
      <!-- {{recurringPaymentTxData | json}} -->
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <!-- <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant Id</th> -->
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant DBA</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Expected Avg</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Last 7Days Avg</th>
            <!-- <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 1</th>            
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Day 2</th>            
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 3</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 4</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 5</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 6</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Day 7</th> -->
            <th class="pt-0 header_bolder text-left popup-headers" width="20%" style="color: red;"><i class="link-icon feather icon-arrow-down"></i> (% Declining)</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant Email</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant Phone</th>
          </tr>
        </thead>                     
        <tbody>

          <tr *ngFor="let merchant of LSMList">
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.merchantId) || 'N/A'}}</span>
            </td> -->
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.merchantdba) || 'N/A'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">${{(merchant.AVG3Month) || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">${{(merchant.AVG7Days) || '0'}}</span>
            </td>
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day1 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day2 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day3 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day4 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day5 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day6 || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.Day7 || '0'}}</span>
            </td> -->
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave" style="color: red;">{{merchant.Diff || '0'}}%</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.email || '0'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.phoneNumber || '0'}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>